var map = {
	"app/anonymisation/anonymisation.module": [
		"./src/app/anonymisation/anonymisation.module.ts",
		"app-anonymisation-anonymisation-module"
	],
	"app/classification-categories/classification-categories.module": [
		"./src/app/classification-categories/classification-categories.module.ts",
		"app-classification-categories-classification-categories-module"
	],
	"app/classification-search-report/classification-search-report.module": [
		"./src/app/classification-search-report/classification-search-report.module.ts",
		"common",
		"app-classification-search-report-classification-search-report-module"
	],
	"app/classification/classification.module": [
		"./src/app/classification/classification.module.ts"
	],
	"app/classify-report/classify-report.module": [
		"./src/app/classify-report/classify-report.module.ts",
		"app-classify-report-classify-report-module"
	],
	"app/connections/connections.module": [
		"./src/app/connections/connections.module.ts",
		"app-connections-connections-module"
	],
	"app/dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"app-dashboard-dashboard-module"
	],
	"app/data-retention-policies/data-retention-policies.module": [
		"./src/app/data-retention-policies/data-retention-policies.module.ts",
		"common",
		"app-data-retention-policies-data-retention-policies-module"
	],
	"app/deletion-approvals/deletion-approvals.module": [
		"./src/app/deletion-approvals/deletion-approvals.module.ts",
		"app-deletion-approvals-deletion-approvals-module"
	],
	"app/layout/layout.module": [
		"./src/app/layout/layout.module.ts"
	],
	"app/login/login.module": [
		"./src/app/login/login.module.ts",
		"app-login-login-module"
	],
	"app/master-mappings-report/master-mappings-report.module": [
		"./src/app/master-mappings-report/master-mappings-report.module.ts",
		"app-master-mappings-report-master-mappings-report-module"
	],
	"app/master-mappings/master-mappings.module": [
		"./src/app/master-mappings/master-mappings.module.ts"
	],
	"app/search/search.module": [
		"./src/app/search/search.module.ts",
		"common",
		"app-search-search-module"
	],
	"app/transform/batch-setup/batch-setup.module": [
		"./src/app/transform/batch-setup/batch-setup.module.ts",
		"app-transform-batch-setup-batch-setup-module"
	],
	"app/transform/transform.module": [
		"./src/app/transform/transform.module.ts",
		"common",
		"app-transform-transform-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;